import { FC } from 'react'
import { Head, usePage } from '@inertiajs/react'
import { ClientPageProps } from 'types'

type TProps = {
  title?: string
}

const AppHead: FC<TProps> = ({ title }) => {
  const {
    props: { canonical },
  } = usePage<ClientPageProps>()

  return (
    <Head>
      <title>{title ?? 'D-Console'}</title>
      <meta name="description" content={''} />
      <meta property="og:description" content={''} />
      <meta property="og:title" content={'Dconsole'} />
      {/* <meta property="og:url" content={canonical} /> */}
      {/* <meta property="og:image" content={Logo} /> */}
      <link rel="canonical" href={canonical} />
    </Head>
  )
}

export { AppHead }
